import React, { useState, useEffect } from 'react';
import {
  TextField,
  Button,
  Paper,
  Typography,
  Box,
  Snackbar,
  Alert,
  FormControlLabel,
  Checkbox,
  FormControl,
  InputLabel,
  Select,
  MenuItem
} from '@mui/material';
import { savePrinter } from '../../../../../services/Settings/printers';
import { fetchActiveBranches } from '../../../../../services/dashboard/apiServiceDashboard';

const AddPrinterForm = ({ onSuccess, defaultRootId = '' }) => {
  const [formData, setFormData] = useState({
    root_id: '',
    name: '',
    cashier_printer: false,
    kitchen_printer: false, // New field for kitchen printer
    local_url: '' // New field for additional information
  });
  const [branches, setBranches] = useState([]);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState(null);

  useEffect(() => {
    const loadBranches = async () => {
      try {
        const data = await fetchActiveBranches();
        setBranches(data);
      } catch (error) {
        console.error("❌ فشل في تحميل الفروع:", error.message);
        setMessage({ type: 'error', text: 'فشل في تحميل الفروع' });
      }
    };
    loadBranches();
  }, []);

  useEffect(() => {
    if (defaultRootId) {
      setFormData(prev => ({
        ...prev,
        root_id: defaultRootId
      }));
    }
  }, [defaultRootId]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage(null);

    try {
      await savePrinter({
        ...formData,
        cashier_printer: formData.cashier_printer ? "1" : "0",
        kitchen_printer: formData.kitchen_printer ? "1" : "0",
        additional_info: formData.additional_info || "", // Include additional info field
      });
      setMessage({ type: 'success', text: '✅ تم حفظ الطابعة بنجاح' });
      setFormData({ root_id: '', name: '', cashier_printer: false, kitchen_printer: false, additional_info: '' });

      if (onSuccess) onSuccess();
    } catch (error) {
      console.error("🚫 خطأ أثناء حفظ الطابعة:", error.message);
      setMessage({ type: 'error', text: error.message });
    } finally {
      setLoading(false);
    }
  };

  const handleCloseSnackbar = () => setMessage(null);

  return (
    <Paper sx={{ p: 3, maxWidth: 600, mx: 'auto' }}>
      <Typography variant="h6" gutterBottom>🖨️ إضافة طابعة جديدة</Typography>
      <form onSubmit={handleSubmit}>
        <FormControl fullWidth margin="normal">
          <InputLabel>اختر الفرع</InputLabel>
          <Select
            name="root_id"
            value={formData.root_id}
            onChange={handleChange}
            required
          >
            {branches.map((branch) => (
              <MenuItem key={branch.id} value={branch.id}>
                {branch.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <TextField
          label="اسم الطابعة"
          name="name"
          value={formData.name}
          onChange={handleChange}
          fullWidth
          margin="normal"
          required
        />
          <TextField
                    label="رابط التوصيل المحلى (ضروري)"

          name="local_url"
          value={formData.local_url || ""}
          onChange={handleChange}
          fullWidth
          margin="normal"
        />

        <FormControlLabel
          control={
            <Checkbox
              checked={formData.cashier_printer}
              onChange={handleChange}
              name="cashier_printer"
            />
          }
          label="هل الطابعة للكاشير؟"
        />

       

      

        <Button type="submit" variant="contained" color="primary" fullWidth sx={{ mt: 2 }} disabled={loading}>
          {loading ? 'جارٍ الحفظ...' : 'حفظ الطابعة'}
        </Button>
      </form>

      {message && (
        <Snackbar open autoHideDuration={4000} onClose={handleCloseSnackbar}>
          <Alert onClose={handleCloseSnackbar} severity={message.type} sx={{ width: '100%' }}>
            {message.text}
          </Alert>
        </Snackbar>
      )}
    </Paper>
  );
};

export default AddPrinterForm;
